module.exports = __webpack_public_path__ + "static/05_Bain-55726dac06c0ec15466f6595f9b4ae7b.png";